import { render, staticRenderFns } from "./recentLiveCourse.vue?vue&type=template&id=c92ae244&scoped=true&"
import script from "./recentLiveCourse.vue?vue&type=script&lang=js&"
export * from "./recentLiveCourse.vue?vue&type=script&lang=js&"
import style0 from "./recentLiveCourse.vue?vue&type=style&index=0&id=c92ae244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92ae244",
  null
  
)

export default component.exports